export const Overview = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H8C8.79565 3 9.55871 3.31607 10.1213 3.87868C10.6839 4.44129 11 5.20435 11 6V8C11 8.79565 10.6839 9.55871 10.1213 10.1213C9.55871 10.6839 8.79565 11 8 11H6C5.20435 11 4.44129 10.6839 3.87868 10.1213C3.31607 9.55871 3 8.79565 3 8V6C3 5.20435 3.31607 4.44129 3.87868 3.87868ZM6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V8C5 8.26522 5.10536 8.51957 5.29289 8.70711C5.48043 8.89464 5.73478 9 6 9H8C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8V6C9 5.73478 8.89464 5.48043 8.70711 5.29289C8.51957 5.10536 8.26522 5 8 5H6ZM13.8787 3.87868C14.4413 3.31607 15.2044 3 16 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V8C21 8.79565 20.6839 9.55871 20.1213 10.1213C19.5587 10.6839 18.7957 11 18 11H16C15.2043 11 14.4413 10.6839 13.8787 10.1213C13.3161 9.55871 13 8.79565 13 8V6C13 5.20435 13.3161 4.44129 13.8787 3.87868ZM16 5C15.7348 5 15.4804 5.10536 15.2929 5.29289C15.1054 5.48043 15 5.73478 15 6V8C15 8.26522 15.1054 8.51957 15.2929 8.70711C15.4804 8.89464 15.7348 9 16 9H18C18.2652 9 18.5196 8.89464 18.7071 8.70711C18.8946 8.51957 19 8.26522 19 8V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5H16ZM3.87868 13.8787C4.44129 13.3161 5.20435 13 6 13H8C8.79565 13 9.55871 13.3161 10.1213 13.8787C10.6839 14.4413 11 15.2043 11 16V18C11 18.7957 10.6839 19.5587 10.1213 20.1213C9.55871 20.6839 8.79565 21 8 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V16C3 15.2044 3.31607 14.4413 3.87868 13.8787ZM6 15C5.73478 15 5.48043 15.1054 5.29289 15.2929C5.10536 15.4804 5 15.7348 5 16V18C5 18.2652 5.10536 18.5196 5.29289 18.7071C5.48043 18.8946 5.73478 19 6 19H8C8.26522 19 8.51957 18.8946 8.70711 18.7071C8.89464 18.5196 9 18.2652 9 18V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15H6ZM17 13C17.5523 13 18 13.4477 18 14V16H20C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H18V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V18H14C13.4477 18 13 17.5523 13 17C13 16.4477 13.4477 16 14 16H16V14C16 13.4477 16.4477 13 17 13Z"
      fill="#333333"
    />
  </svg>
);
export const Gst = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1634_173)">
      <path
        d="M7 12.4854L10 15.4854L17 8.48535M20 15.4854C19 16.4854 21.25 19.2354 20 20.4854C18.75 21.7354 16 19.4854 15 20.4854C14 21.4854 13.5 23.4854 12 23.4854C10.5 23.4854 10 21.4854 9 20.4854C8 19.4854 5.25 21.7354 4 20.4854C2.75 19.2354 5 16.4854 4 15.4854C3 14.4854 1 13.9854 1 12.4854C1 10.9854 3 10.4854 4 9.48535C5 8.48535 2.75 5.73535 4 4.48535C5.25 3.23535 8 5.48535 9 4.48535C10 3.48535 10.5 1.48535 12 1.48535C13.5 1.48535 14 3.48535 15 4.48535C16 5.48535 18.75 3.23535 20 4.48535C21.25 5.73535 19 8.48535 20 9.48535C21 10.4854 23 10.9854 23 12.4854C23 13.9854 21 14.4854 20 15.4854Z"
        stroke="black"
        stroke-width="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1634_173">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.485352)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Jobs = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8787 1.87868C8.44131 1.31607 9.20437 1 10 1H14C14.7957 1 15.5587 1.31607 16.1213 1.87868C16.6839 2.44129 17 3.20435 17 4V5H19C19.7957 5 20.5587 5.31607 21.1213 5.87868C21.684 6.44129 22 7.20435 22 8V13.2317C22.0004 13.247 22.0004 13.2624 22 13.2776V18C22 18.7957 21.684 19.5587 21.1213 20.1213C20.5587 20.6839 19.7957 21 19 21H5.00002C4.20437 21 3.44131 20.6839 2.8787 20.1213C2.31609 19.5587 2.00002 18.7957 2.00002 18V13.2776C1.99967 13.2623 1.99967 13.247 2.00002 13.2317V8C2.00002 7.20435 2.31609 6.44129 2.8787 5.87868C3.44131 5.31607 4.20437 5 5.00002 5H7.00002V4C7.00002 3.20435 7.31609 2.44129 7.8787 1.87868ZM5.00002 7C4.7348 7 4.48045 7.10536 4.29291 7.29289C4.10538 7.48043 4.00002 7.73478 4.00002 8V12.5703C6.49099 13.4944 9.18498 14 12 14L12.0012 14C14.7331 14.0033 17.4418 13.5185 20 12.5701V8C20 7.73478 19.8947 7.48043 19.7071 7.29289C19.5196 7.10536 19.2652 7 19 7H5.00002ZM15 5H9.00002V4C9.00002 3.73478 9.10538 3.48043 9.29291 3.29289C9.48045 3.10536 9.7348 3 10 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8947 3.48043 15 3.73478 15 4V5ZM20 14.6915C17.4255 15.5602 14.7231 16.0033 11.9994 16C9.20278 15.9999 6.51277 15.54 4.00002 14.6918V18C4.00002 18.2652 4.10538 18.5196 4.29291 18.7071C4.48045 18.8946 4.7348 19 5.00002 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8947 18.5196 20 18.2652 20 18V14.6915ZM11 12C11 11.4477 11.4477 11 12 11H12.01C12.5623 11 13.01 11.4477 13.01 12C13.01 12.5523 12.5623 13 12.01 13H12C11.4477 13 11 12.5523 11 12Z"
      fill="#333333"
    />
  </svg>
);
export const Customers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11 5H13V19H11V5ZM5 12C6.1 12 7 11.1 7 10C7 8.9 6.1 8 5 8C3.9 8 3 8.9 3 10C3 11.1 3.9 12 5 12ZM7.78 13.58C6.90315 13.1973 5.95673 12.9998 5 12.9998C4.04328 12.9998 3.09685 13.1973 2.22 13.58C1.85771 13.7349 1.54892 13.9928 1.33202 14.3217C1.11511 14.6506 0.999656 15.036 1 15.43V16H9V15.43C9 14.62 8.52 13.9 7.78 13.58ZM19 12C20.1 12 21 11.1 21 10C21 8.9 20.1 8 19 8C17.9 8 17 8.9 17 10C17 11.1 17.9 12 19 12ZM21.78 13.58C20.9031 13.1973 19.9567 12.9998 19 12.9998C18.0433 12.9998 17.0969 13.1973 16.22 13.58C15.8577 13.7349 15.5489 13.9928 15.332 14.3217C15.1151 14.6506 14.9997 15.036 15 15.43V16H23V15.43C23 14.62 22.52 13.9 21.78 13.58Z"
      fill="#333333"
    />
  </svg>
);
export const Contractors = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 9C16 14.33 8 14.33 8 9H10C10 11.67 14 11.67 14 9M20 18V21H4V18C4 15.33 9.33 14 12 14C14.67 14 20 15.33 20 18ZM18.1 18C18.1 17.36 14.97 15.9 12 15.9C9.03 15.9 5.9 17.36 5.9 18V19.1H18.1M12.5 2C12.78 2 13 2.22 13 2.5V5.5H14V3C14.7077 3.32752 15.3006 3.86019 15.7019 4.52889C16.1031 5.19758 16.294 5.97142 16.25 6.75C16.25 6.75 16.95 6.89 17 8H7C7 6.89 7.75 6.75 7.75 6.75C7.70595 5.97142 7.89693 5.19758 8.29814 4.52889C8.69936 3.86019 9.29229 3.32752 10 3V5.5H11V2.5C11 2.22 11.22 2 11.5 2"
      fill="#333333"
    />
  </svg>
);
export const Transactions = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2425 3.02985C11.7783 3.1638 12.1041 3.70673 11.9701 4.24253L11.0308 7.99999H14.9692L16.0299 3.75746C16.1638 3.22166 16.7067 2.8959 17.2425 3.02985C17.7783 3.1638 18.1041 3.70673 17.9701 4.24253L17.0308 7.99999H20C20.5523 7.99999 21 8.44771 21 8.99999C21 9.55228 20.5523 9.99999 20 9.99999H16.5308L15.5308 14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H15.0308L13.9701 20.2425C13.8362 20.7783 13.2933 21.1041 12.7575 20.9701C12.2217 20.8362 11.8959 20.2933 12.0299 19.7575L12.9692 16H9.03078L7.97014 20.2425C7.83619 20.7783 7.29326 21.1041 6.75746 20.9701C6.22167 20.8362 5.89591 20.2933 6.02986 19.7575L6.96922 16H4C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14H7.46922L8.46922 9.99999H6C5.44772 9.99999 5 9.55228 5 8.99999C5 8.44771 5.44772 7.99999 6 7.99999H8.96922L10.0299 3.75746C10.1638 3.22166 10.7067 2.8959 11.2425 3.02985ZM10.5308 9.99999L9.53078 14H13.4692L14.4692 9.99999H10.5308Z"
      fill="#333333"
    />
  </svg>
);
export const RFReps = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9 15C6.33 15 1 16.34 1 19V21H17V19C17 16.34 11.67 15 9 15ZM3 19C3.22 18.28 6.31 17 9 17C11.7 17 14.8 18.29 15 19H3ZM4.74 9H5C5 11.21 6.79 13 9 13C11.21 13 13 11.21 13 9H13.26C13.53 9 13.75 8.78 13.75 8.51V8.49C13.75 8.36004 13.6984 8.23541 13.6065 8.14352C13.5146 8.05162 13.39 8 13.26 8H13C13 6.52 12.19 5.25 11 4.55V5.5C11 5.78 10.78 6 10.5 6C10.22 6 10 5.78 10 5.5V4.14C9.68 4.06 9.35 4 9 4C8.65 4 8.32 4.06 8 4.14V5.5C8 5.78 7.78 6 7.5 6C7.22 6 7 5.78 7 5.5V4.55C5.81 5.25 5 6.52 5 8H4.74C4.67565 8 4.61193 8.01267 4.55248 8.0373C4.49304 8.06192 4.43902 8.09802 4.39352 8.14352C4.34802 8.18902 4.31192 8.24304 4.2873 8.30249C4.26267 8.36194 4.25 8.42565 4.25 8.49V8.52C4.25 8.78 4.47 9 4.74 9ZM11 9C11 10.1 10.1 11 9 11C7.9 11 7 10.1 7 9H11ZM21.98 6.23L22.91 5.4L22.16 4.1L20.97 4.49C20.83 4.38 20.67 4.29 20.5 4.22L20.25 3H18.75L18.5 4.22C18.33 4.29 18.17 4.38 18.02 4.49L16.84 4.1L16.09 5.4L17.02 6.23C17 6.4 17 6.58 17.02 6.75L16.09 7.6L16.84 8.9L18.04 8.52C18.17 8.62 18.32 8.7 18.47 8.77L18.75 10H20.25L20.52 8.78C20.68 8.71 20.82 8.63 20.96 8.53L22.15 8.91L22.9 7.61L21.97 6.76C22 6.57 21.99 6.4 21.98 6.23ZM19.5 7.75C19.1685 7.75 18.8505 7.6183 18.6161 7.38388C18.3817 7.14946 18.25 6.83152 18.25 6.5C18.25 6.16848 18.3817 5.85054 18.6161 5.61612C18.8505 5.3817 19.1685 5.25 19.5 5.25C19.8315 5.25 20.1495 5.3817 20.3839 5.61612C20.6183 5.85054 20.75 6.16848 20.75 6.5C20.75 6.83152 20.6183 7.14946 20.3839 7.38388C20.1495 7.6183 19.8315 7.75 19.5 7.75ZM19.4 10.79L18.55 11.07C18.45 10.99 18.34 10.93 18.22 10.88L18.04 10H16.97L16.79 10.87C16.67 10.92 16.55 10.99 16.45 11.06L15.61 10.78L15.07 11.71L15.73 12.3C15.72 12.43 15.72 12.55 15.73 12.67L15.07 13.28L15.61 14.21L16.47 13.94C16.57 14.01 16.67 14.07 16.78 14.12L16.96 15H18.03L18.22 14.13C18.33 14.08 18.44 14.02 18.54 13.95L19.39 14.22L19.93 13.29L19.27 12.68C19.28 12.55 19.28 12.43 19.27 12.31L19.93 11.72L19.4 10.79ZM17.5 13.39C17.01 13.39 16.61 12.99 16.61 12.5C16.61 12.01 17.01 11.61 17.5 11.61C17.99 11.61 18.39 12.01 18.39 12.5C18.39 12.99 17.99 13.39 17.5 13.39Z"
      fill="#333333"
    />
  </svg>
);
export const Customise = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5 18H11.325C11.4417 18.3667 11.575 18.7167 11.725 19.05C11.875 19.3833 12.0583 19.7 12.275 20H3V2H21V9.65C20.6833 9.5 20.3583 9.379 20.025 9.287C19.6917 9.195 19.35 9.12467 19 9.076V4H5V13H9.2C9.35 13.45 9.6 13.8417 9.95 14.175C10.3 14.5083 10.6917 14.7417 11.125 14.875C11.075 15.2083 11.0417 15.546 11.025 15.888C11.0083 16.23 11.025 16.5673 11.075 16.9C10.475 16.7833 9.91267 16.5623 9.388 16.237C8.86333 15.9117 8.40067 15.4993 8 15H5V18ZM17.025 21L16.725 19.5C16.525 19.4167 16.3373 19.3293 16.162 19.238C15.9867 19.1467 15.8077 19.034 15.625 18.9L14.175 19.35L13.175 17.65L14.325 16.65C14.2917 16.45 14.275 16.2333 14.275 16C14.275 15.7667 14.2917 15.55 14.325 15.35L13.175 14.35L14.175 12.65L15.625 13.1C15.8083 12.9667 15.9877 12.8543 16.163 12.763C16.3383 12.6717 16.5257 12.584 16.725 12.5L17.025 11H19.025L19.325 12.5C19.525 12.5833 19.7127 12.671 19.888 12.763C20.0633 12.855 20.2423 12.9673 20.425 13.1L21.875 12.65L22.875 14.35L21.725 15.35C21.7583 15.55 21.775 15.7667 21.775 16C21.775 16.2333 21.7583 16.45 21.725 16.65L22.875 17.65L21.875 19.35L20.425 18.9C20.2417 19.0333 20.0627 19.146 19.888 19.238C19.7133 19.33 19.5257 19.4173 19.325 19.5L19.025 21H17.025ZM18.025 18C18.575 18 19.046 17.8043 19.438 17.413C19.83 17.0217 20.0257 16.5507 20.025 16C20.025 15.45 19.8293 14.9793 19.438 14.588C19.0467 14.1967 18.5757 14.0007 18.025 14C17.475 14 17.0043 14.196 16.613 14.588C16.2217 14.98 16.0257 15.4507 16.025 16C16.025 16.55 16.221 17.021 16.613 17.413C17.005 17.805 17.4757 18.0007 18.025 18Z"
      fill="#333333"
    />
  </svg>
);
export const AccountSettings = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.6751 14.6649L20.1399 13.3524C20.2126 12.907 20.2501 12.4523 20.2501 11.9977C20.2501 11.543 20.2126 11.0883 20.1399 10.643L21.6751 9.33047C21.7908 9.23135 21.8737 9.09932 21.9127 8.95196C21.9516 8.80459 21.9447 8.64886 21.893 8.50547L21.8719 8.44454C21.4493 7.26335 20.8165 6.16837 20.004 5.21251L19.9618 5.16329C19.8632 5.04739 19.7318 4.96408 19.585 4.92434C19.4381 4.88459 19.2827 4.89027 19.1391 4.94063L17.2336 5.61797C16.5305 5.04141 15.7454 4.58672 14.8969 4.26798L14.529 2.27579C14.5012 2.12589 14.4285 1.98798 14.3205 1.88039C14.2125 1.7728 14.0743 1.70062 13.9243 1.67344L13.861 1.66172C12.6399 1.44141 11.3555 1.44141 10.1344 1.66172L10.0711 1.67344C9.92114 1.70062 9.78295 1.7728 9.67494 1.88039C9.56694 1.98798 9.49422 2.12589 9.46646 2.27579L9.09615 4.27735C8.25448 4.59617 7.47068 5.05061 6.77584 5.62266L4.8563 4.94063C4.71279 4.88987 4.55722 4.88398 4.41028 4.92376C4.26333 4.96353 4.13197 5.04707 4.03365 5.16329L3.99146 5.21251C3.17993 6.16905 2.54718 7.26384 2.12349 8.44454L2.1024 8.50547C1.99693 8.79844 2.08365 9.12657 2.32037 9.33047L3.87427 10.657C3.80162 11.0977 3.76646 11.5477 3.76646 11.9953C3.76646 12.4453 3.80162 12.8953 3.87427 13.3336L2.32037 14.6602C2.20457 14.7593 2.1217 14.8913 2.08277 15.0387C2.04383 15.1861 2.05068 15.3418 2.1024 15.4852L2.12349 15.5461C2.54771 16.7274 3.17583 17.8172 3.99146 18.7781L4.03365 18.8274C4.13221 18.9432 4.26358 19.0266 4.41043 19.0663C4.55729 19.106 4.71274 19.1004 4.8563 19.05L6.77584 18.368C7.47427 18.9422 8.25474 19.3969 9.09615 19.7133L9.46646 21.7149C9.49422 21.8648 9.56694 22.0027 9.67494 22.1102C9.78295 22.2178 9.92114 22.29 10.0711 22.3172L10.1344 22.3289C11.3667 22.5504 12.6287 22.5504 13.861 22.3289L13.9243 22.3172C14.0743 22.29 14.2125 22.2178 14.3205 22.1102C14.4285 22.0027 14.5012 21.8648 14.529 21.7149L14.8969 19.7227C15.745 19.4047 16.5346 18.9486 17.2336 18.3727L19.1391 19.05C19.2826 19.1008 19.4382 19.1067 19.5851 19.0669C19.7321 19.0271 19.8634 18.9436 19.9618 18.8274L20.004 18.7781C20.8196 17.8148 21.4477 16.7274 21.8719 15.5461L21.893 15.4852C21.9985 15.1969 21.9118 14.8688 21.6751 14.6649ZM18.4758 10.9195C18.5344 11.2734 18.5649 11.6367 18.5649 12C18.5649 12.3633 18.5344 12.7266 18.4758 13.0805L18.3211 14.0203L20.0719 15.518C19.8065 16.1294 19.4715 16.7083 19.0735 17.243L16.8985 16.4719L16.1626 17.0766C15.6024 17.5359 14.979 17.8969 14.304 18.15L13.411 18.4852L12.9915 20.7586C12.3295 20.8336 11.6612 20.8336 10.9993 20.7586L10.5797 18.4805L9.6938 18.1406C9.02584 17.8875 8.40474 17.5266 7.84927 17.0695L7.11334 16.4625L4.92427 17.2406C4.52584 16.7039 4.19302 16.125 3.92583 15.5156L5.69537 14.0039L5.54302 13.0664C5.48677 12.7172 5.4563 12.3563 5.4563 12C5.4563 11.6414 5.48443 11.2828 5.54302 10.9336L5.69537 9.9961L3.92583 8.48438C4.19068 7.87266 4.52584 7.2961 4.92427 6.75938L7.11334 7.53751L7.84927 6.93048C8.40474 6.47344 9.02584 6.11251 9.6938 5.85938L10.5821 5.52422L11.0016 3.2461C11.6602 3.1711 12.3329 3.1711 12.9938 3.2461L13.4133 5.51954L14.3063 5.85469C14.979 6.10782 15.6047 6.46876 16.1649 6.92813L16.9008 7.53282L19.0758 6.76172C19.4743 7.29844 19.8071 7.87735 20.0743 8.48672L18.3235 9.98438L18.4758 10.9195ZM12.0001 7.64063C9.72193 7.64063 7.87505 9.48751 7.87505 11.7656C7.87505 14.0438 9.72193 15.8906 12.0001 15.8906C14.2782 15.8906 16.1251 14.0438 16.1251 11.7656C16.1251 9.48751 14.2782 7.64063 12.0001 7.64063ZM13.8563 13.6219C13.6128 13.866 13.3235 14.0597 13.0049 14.1916C12.6864 14.3235 12.3449 14.3912 12.0001 14.3906C11.2993 14.3906 10.6407 14.1164 10.1438 13.6219C9.89964 13.3784 9.70602 13.0891 9.57409 12.7705C9.44216 12.4519 9.37452 12.1104 9.37505 11.7656C9.37505 11.0648 9.64927 10.4063 10.1438 9.90938C10.6407 9.41251 11.2993 9.14063 12.0001 9.14063C12.7008 9.14063 13.3594 9.41251 13.8563 9.90938C14.1005 10.1528 14.2941 10.4422 14.426 10.7607C14.5579 11.0793 14.6256 11.4208 14.6251 11.7656C14.6251 12.4664 14.3508 13.125 13.8563 13.6219Z"
      fill="#333333"
    />
  </svg>
);

export const HeaderSearch = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3334 5.33329C11.2116 5.33329 9.17679 6.17615 7.6765 7.67644C6.17621 9.17673 5.33335 11.2116 5.33335 13.3333C5.33335 14.3839 5.54028 15.4242 5.94232 16.3948C6.34436 17.3654 6.93363 18.2473 7.6765 18.9901C8.41937 19.733 9.30128 20.3223 10.2719 20.7243C11.2425 21.1264 12.2828 21.3333 13.3334 21.3333C14.3839 21.3333 15.4242 21.1264 16.3948 20.7243C17.3654 20.3223 18.2473 19.733 18.9902 18.9901C19.7331 18.2473 20.3224 17.3654 20.7244 16.3948C21.1264 15.4242 21.3334 14.3839 21.3334 13.3333C21.3334 11.2116 20.4905 9.17673 18.9902 7.67644C17.4899 6.17615 15.4551 5.33329 13.3334 5.33329ZM5.79088 5.79082C7.79127 3.79043 10.5044 2.66663 13.3334 2.66663C16.1623 2.66663 18.8754 3.79043 20.8758 5.79082C22.8762 7.79121 24 10.5043 24 13.3333C24 14.7341 23.7241 16.1211 23.1881 17.4153C22.823 18.2967 22.342 19.1233 21.7595 19.8738L28.9428 27.0571C29.4635 27.5779 29.4635 28.4221 28.9428 28.9428C28.4221 29.4635 27.5779 29.4635 27.0572 28.9428L19.8739 21.7594C19.1233 22.342 18.2968 22.8229 17.4153 23.188C16.1212 23.7241 14.7341 24 13.3334 24C11.9326 24 10.5455 23.7241 9.2514 23.188C7.95726 22.652 6.78137 21.8663 5.79088 20.8758C4.80039 19.8853 4.01469 18.7094 3.47864 17.4153C2.94259 16.1211 2.66669 14.7341 2.66669 13.3333C2.66669 10.5043 3.79049 7.79121 5.79088 5.79082Z"
      fill="#555555"
    />
  </svg>
);

export const NotificationBell = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16 29.3334C17.4666 29.3334 18.6666 28.1334 18.6666 26.6667H13.3333C13.3333 28.1334 14.5333 29.3334 16 29.3334ZM24 21.3334V14.6667C24 10.5734 21.8266 7.14671 18 6.24004V5.33337C18 4.22671 17.1066 3.33337 16 3.33337C14.8933 3.33337 14 4.22671 14 5.33337V6.24004C10.1866 7.14671 7.99998 10.56 7.99998 14.6667V21.3334L5.33331 24V25.3334H26.6666V24L24 21.3334ZM21.3333 22.6667H10.6666V14.6667C10.6666 11.36 12.68 8.66671 16 8.66671C19.32 8.66671 21.3333 11.36 21.3333 14.6667V22.6667Z"
      fill="#333333"
    />
  </svg>
);

export const Logout = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z"
      fill="#333333"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"
      fill="#4B4B4B"
    />
  </svg>
);

export const RatingStar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
  >
    <path
      d="M3.38773 1.69263C3.81652 0.372967 5.68348 0.372967 6.11227 1.69263C6.30402 2.2828 6.85399 2.68237 7.47453 2.68237C8.86211 2.68237 9.43903 4.45796 8.31646 5.27356C7.81443 5.6383 7.60436 6.28483 7.79612 6.875C8.22491 8.19466 6.7145 9.29204 5.59193 8.47644C5.0899 8.1117 4.4101 8.1117 3.90807 8.47644C2.7855 9.29204 1.27509 8.19466 1.70388 6.875C1.89564 6.28483 1.68557 5.6383 1.18354 5.27356C0.0609684 4.45796 0.637893 2.68237 2.02547 2.68237C2.64601 2.68237 3.19597 2.2828 3.38773 1.69263Z"
      fill="#BBBBBB"
    />
  </svg>
);

export const TotalCustomers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
  >
    <path
      d="M10.6638 5H12.4857V19H10.6638V5ZM5.19827 12C6.20029 12 7.02012 11.1 7.02012 10C7.02012 8.9 6.20029 8 5.19827 8C4.19625 8 3.37642 8.9 3.37642 10C3.37642 11.1 4.19625 12 5.19827 12ZM7.73064 13.58C6.93189 13.1973 6.06977 12.9998 5.19827 12.9998C4.32676 12.9998 3.46464 13.1973 2.6659 13.58C2.33588 13.7349 2.05459 13.9928 1.85701 14.3217C1.65942 14.6506 1.55425 15.036 1.55457 15.43V16H8.84197V15.43C8.84197 14.62 8.40473 13.9 7.73064 13.58ZM17.9512 12C18.9532 12 19.7731 11.1 19.7731 10C19.7731 8.9 18.9532 8 17.9512 8C16.9492 8 16.1294 8.9 16.1294 10C16.1294 11.1 16.9492 12 17.9512 12ZM20.4836 13.58C19.6849 13.1973 18.8227 12.9998 17.9512 12.9998C17.0797 12.9998 16.2176 13.1973 15.4189 13.58C15.0888 13.7349 14.8076 13.9928 14.61 14.3217C14.4124 14.6506 14.3072 15.036 14.3075 15.43V16H21.5949V15.43C21.5949 14.62 21.1577 13.9 20.4836 13.58Z"
      fill="#4D0A53"
    />
  </svg>
);

export const TotalContractors = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 9C16 14.33 8 14.33 8 9H10C10 11.67 14 11.67 14 9M20 18V21H4V18C4 15.33 9.33 14 12 14C14.67 14 20 15.33 20 18ZM18.1 18C18.1 17.36 14.97 15.9 12 15.9C9.03 15.9 5.9 17.36 5.9 18V19.1H18.1M12.5 2C12.78 2 13 2.22 13 2.5V5.5H14V3C14.7077 3.32752 15.3006 3.86019 15.7019 4.52889C16.1031 5.19758 16.294 5.97142 16.25 6.75C16.25 6.75 16.95 6.89 17 8H7C7 6.89 7.75 6.75 7.75 6.75C7.70595 5.97142 7.89693 5.19758 8.29814 4.52889C8.69936 3.86019 9.29229 3.32752 10 3V5.5H11V2.5C11 2.22 11.22 2 11.5 2"
      fill="#222B53"
    />
  </svg>
);

export const TotalRevenue = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.88 14.5089H11.9325C13.0575 14.5389 13.9575 15.4539 13.9575 16.5789C13.9575 17.5389 13.305 18.3414 12.42 18.5814V19.4214C12.42 19.7214 12.18 19.9614 11.88 19.9614C11.58 19.9614 11.34 19.7214 11.34 19.4214V18.5814C10.8993 18.4629 10.5099 18.2026 10.232 17.8406C9.9541 17.4787 9.80315 17.0352 9.80249 16.5789C9.80249 16.2789 10.0425 16.0389 10.3425 16.0389C10.6425 16.0389 10.8825 16.2789 10.8825 16.5789C10.8825 17.1339 11.325 17.5764 11.8725 17.5764C12.42 17.5764 12.87 17.1264 12.87 16.5789C12.87 16.0314 12.42 15.5814 11.8725 15.5814H11.82C11.2805 15.5668 10.7679 15.3423 10.3912 14.9558C10.0144 14.5693 9.80327 14.0511 9.80249 13.5114C9.80249 12.5514 10.455 11.7489 11.34 11.5089V10.6689C11.34 10.3689 11.58 10.1289 11.88 10.1289C12.18 10.1289 12.42 10.3689 12.42 10.6689V11.5089C13.305 11.7489 13.9575 12.5514 13.9575 13.5114C13.9575 13.8114 13.7175 14.0514 13.4175 14.0514C13.1175 14.0514 12.8775 13.8114 12.8775 13.5114C12.8775 12.9639 12.4275 12.5139 11.88 12.5139C11.3325 12.5139 10.8825 12.9639 10.8825 13.5114C10.8825 14.0589 11.3325 14.5089 11.88 14.5089Z"
      fill="#745D1D"
    />
    <path
      d="M7.899 3.82514L9.9885 6.27014L9.76275 6.52214C5.46225 7.48664 2.25 11.3274 2.25 15.9189C2.25 19.9554 5.526 23.2314 9.5625 23.2314H14.19C18.2265 23.2314 21.5025 19.9561 21.5025 15.9196C21.51 11.3274 18.2977 7.48664 13.9972 6.52214C14.0147 6.36365 13.9861 6.20349 13.9147 6.06089L15.6922 4.02614L15.807 3.84914C15.941 3.55689 15.9753 3.22871 15.9046 2.91507C15.8338 2.60144 15.6621 2.31972 15.4156 2.11324C15.1692 1.90677 14.8617 1.78697 14.5405 1.77227C14.2194 1.75757 13.9023 1.84879 13.638 2.03189L13.0057 1.28189C12.8639 1.12318 12.6902 0.996127 12.496 0.909026C12.3018 0.821924 12.0914 0.776723 11.8786 0.776369C11.6657 0.776015 11.4552 0.820516 11.2607 0.906972C11.0662 0.993428 10.8921 1.1199 10.7497 1.27814L10.0875 2.01764C9.82391 1.83073 9.50608 1.73587 9.18317 1.74775C8.86025 1.75963 8.55025 1.87757 8.3011 2.08334C8.05196 2.28912 7.87755 2.57125 7.80487 2.8861C7.73218 3.20095 7.76527 3.53098 7.899 3.82514ZM10.7483 4.86389L9.47625 3.39389C9.77176 3.53628 10.1061 3.57672 10.4271 3.50887C10.748 3.44101 11.0374 3.26871 11.25 3.01889L11.85 2.24039L12.516 3.02939C12.7237 3.27087 13.0038 3.4388 13.3146 3.50813C13.6255 3.57746 13.9504 3.54449 14.241 3.41414L12.975 4.86389H10.7483ZM3.75 15.9189C3.75 11.4279 7.389 7.78889 11.88 7.78889C16.371 7.78889 20.01 11.4279 20.0025 15.9174V15.9189C20.0019 17.4603 19.3893 18.9384 18.2994 20.0283C17.2095 21.1182 15.7314 21.7308 14.19 21.7314H9.5625C8.02111 21.7308 6.54303 21.1182 5.4531 20.0283C4.36317 18.9384 3.7506 17.4603 3.75 15.9189Z"
      fill="#745D1D"
    />
  </svg>
);

export const TotalJobs = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8787 1.87868C8.44131 1.31607 9.20437 1 10 1H14C14.7957 1 15.5587 1.31607 16.1213 1.87868C16.6839 2.44129 17 3.20435 17 4V5H19C19.7957 5 20.5587 5.31607 21.1213 5.87868C21.684 6.44129 22 7.20435 22 8V13.2317C22.0004 13.247 22.0004 13.2624 22 13.2776V18C22 18.7957 21.684 19.5587 21.1213 20.1213C20.5587 20.6839 19.7957 21 19 21H5.00002C4.20437 21 3.44131 20.6839 2.8787 20.1213C2.31609 19.5587 2.00002 18.7957 2.00002 18V13.2776C1.99967 13.2623 1.99967 13.247 2.00002 13.2317V8C2.00002 7.20435 2.31609 6.44129 2.8787 5.87868C3.44131 5.31607 4.20437 5 5.00002 5H7.00002V4C7.00002 3.20435 7.31609 2.44129 7.8787 1.87868ZM5.00002 7C4.7348 7 4.48045 7.10536 4.29291 7.29289C4.10538 7.48043 4.00002 7.73478 4.00002 8V12.5703C6.49099 13.4944 9.18498 14 12 14L12.0012 14C14.7331 14.0033 17.4418 13.5185 20 12.5701V8C20 7.73478 19.8947 7.48043 19.7071 7.29289C19.5196 7.10536 19.2652 7 19 7H5.00002ZM15 5H9.00002V4C9.00002 3.73478 9.10538 3.48043 9.29291 3.29289C9.48045 3.10536 9.7348 3 10 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8947 3.48043 15 3.73478 15 4V5ZM20 14.6915C17.4255 15.5602 14.7231 16.0033 11.9994 16C9.20278 15.9999 6.51277 15.54 4.00002 14.6918V18C4.00002 18.2652 4.10538 18.5196 4.29291 18.7071C4.48045 18.8946 4.7348 19 5.00002 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8947 18.5196 20 18.2652 20 18V14.6915ZM11 12C11 11.4477 11.4477 11 12 11H12.01C12.5623 11 13.01 11.4477 13.01 12C13.01 12.5523 12.5623 13 12.01 13H12C11.4477 13 11 12.5523 11 12Z"
      fill="#333333"
    />
  </svg>
);

export const CompletedState = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
  >
    <circle
      cx="4.74659"
      cy="5.51283"
      r="4.24502"
      stroke="#0D8012"
      strokeWidth="0.707493"
    />
    <circle cx="4.74323" cy="5.51288" r="2.47626" fill="#0D8012" />
  </svg>
);

export const ComplaintsState = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
  >
    <circle
      cx="4.74659"
      cy="5.51283"
      r="4.24502"
      stroke="#9A0101"
      strokeWidth="0.707493"
    />
    <circle cx="4.74323" cy="5.51288" r="2.47626" fill="#9A0101" />
  </svg>
);

export const PendingState = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
  >
    <circle
      cx="4.74659"
      cy="5.51295"
      r="4.24502"
      stroke="#00235B"
      strokeWidth="0.707493"
    />
    <circle cx="4.74323" cy="5.513" r="2.47626" fill="#00235B" />
  </svg>
);

export const SuspendedState = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
  >
    <circle
      cx="4.74659"
      cy="5.51295"
      r="4.24502"
      stroke="#FF0000" // Changed to red
      strokeWidth="0.707493"
    />
    <circle cx="4.74323" cy="5.513" r="2.47626" fill="#FF0000" />{" "}
    {/* Changed to red */}
  </svg>
);

export const YellowStar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
  >
    <path
      d="M3.4235 1.69263C3.85228 0.372967 5.71925 0.372967 6.14803 1.69263C6.33979 2.2828 6.88976 2.68237 7.5103 2.68237C8.89787 2.68237 9.4748 4.45796 8.35223 5.27356C7.8502 5.6383 7.64013 6.28483 7.83189 6.875C8.26067 8.19466 6.75026 9.29204 5.62769 8.47644C5.12567 8.1117 4.44587 8.1117 3.94384 8.47644C2.82127 9.29204 1.31086 8.19466 1.73964 6.875C1.9314 6.28483 1.72133 5.6383 1.2193 5.27356C0.096735 4.45796 0.67366 2.68237 2.06123 2.68237C2.68177 2.68237 3.23174 2.2828 3.4235 1.69263Z"
      fill="#DCAE2F"
    />
  </svg>
);

export const JobIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M24 19.5V18H22.4242C22.3275 17.5305 22.1411 17.0841 21.8752 16.6852L22.9928 15.5677L21.9323 14.5072L20.8148 15.6248C20.4159 15.3588 19.9695 15.1724 19.5 15.0758V13.5H18V15.0758C17.5305 15.1725 17.0841 15.3589 16.6852 15.6248L15.5677 14.5072L14.5073 15.5677L15.6248 16.6852C15.3588 17.0841 15.1724 17.5305 15.0757 18H13.5V19.5H15.0757C15.1732 19.9778 15.3637 20.4218 15.6248 20.8148L14.5073 21.9323L15.5677 22.9928L16.6852 21.8752C17.0841 22.1412 17.5305 22.3276 18 22.4242V24H19.5V22.4242C19.9695 22.3275 20.4159 22.1411 20.8148 21.8752L21.9323 22.9928L22.9928 21.9323L21.8752 20.8148C22.1412 20.4159 22.3276 19.9695 22.4242 19.5H24ZM18.75 21C17.5095 21 16.5 19.9905 16.5 18.75C16.5 17.5095 17.5095 16.5 18.75 16.5C19.9905 16.5 21 17.5095 21 18.75C21 19.9905 19.9905 21 18.75 21ZM15 12.75H9C8.60218 12.75 8.22064 12.592 7.93934 12.3107C7.65804 12.0294 7.5 11.6478 7.5 11.25V3C7.5 2.60218 7.65804 2.22064 7.93934 1.93934C8.22064 1.65804 8.60218 1.5 9 1.5H15C15.3978 1.5 15.7794 1.65804 16.0607 1.93934C16.342 2.22064 16.5 2.60218 16.5 3V11.25C16.5 11.6478 16.342 12.0294 16.0607 12.3107C15.7794 12.592 15.3978 12.75 15 12.75ZM9 11.25H15V3H9V11.25Z"
      fill="black"
    />
    <path
      d="M12.75 15.75H6C5.60218 15.75 5.22064 15.592 4.93934 15.3107C4.65804 15.0294 4.5 14.6478 4.5 14.25V5.25H6V14.25H12.75V15.75Z"
      fill="black"
    />
    <path
      d="M9.75 18.75H3C2.17275 18.75 1.5 18.0773 1.5 17.25V8.25H3V17.25H9.75V18.75Z"
      fill="black"
    />
  </svg>
);

export const CancelIconBlue = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_3341_1670)">
      <path
        d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM2.40001 12C2.40473 9.86925 3.11819 7.80063 4.42801 6.12L17.88 19.572C16.4617 20.671 14.7638 21.3505 12.9789 21.5335C11.194 21.7164 9.39354 21.3955 7.78177 20.6071C6.17001 19.8187 4.81145 18.5944 3.8602 17.0731C2.90895 15.5517 2.40309 13.7943 2.40001 12ZM19.572 17.88L6.12 4.428C7.96821 3.0233 10.2628 2.33588 12.5789 2.49304C14.895 2.65021 17.0757 3.6413 18.7172 5.28279C20.3587 6.92429 21.3498 9.10499 21.507 11.4211C21.6641 13.7372 20.9767 16.0318 19.572 17.88Z"
        fill="#00235B"
      />
    </g>
    <defs>
      <clipPath id="clip0_3341_1670">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CancelIconRed = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_3341_1674)">
      <path
        d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM2.40001 12C2.40473 9.86925 3.11819 7.80063 4.42801 6.12L17.88 19.572C16.4617 20.671 14.7638 21.3505 12.9789 21.5335C11.194 21.7164 9.39354 21.3955 7.78177 20.6071C6.17001 19.8187 4.81145 18.5944 3.8602 17.0731C2.90895 15.5517 2.40309 13.7943 2.40001 12ZM19.572 17.88L6.12 4.428C7.96821 3.0233 10.2628 2.33588 12.5789 2.49304C14.895 2.65021 17.0757 3.6413 18.7172 5.28279C20.3587 6.92429 21.3498 9.10499 21.507 11.4211C21.6641 13.7372 20.9767 16.0318 19.572 17.88Z"
        fill="#9A0101"
      />
    </g>
    <defs>
      <clipPath id="clip0_3341_1674">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Analytics = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 18L18.29 15.71L13.41 10.83L9.41 14.83L2 7.41L3.41 6L9.41 12L13.41 8L19.71 14.29L22 12V18H16Z"
      fill="black"
    />
  </svg>
);

export const USFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M18 2.7377C16.2375 1.6502 14.2125 1.0127 12 1.0127V2.7377H18Z"
      fill="#B22334"
    />
    <path
      d="M12 4.4623H20.1C19.4625 3.8248 18.75 3.2248 18 2.7373H12V4.4623Z"
      fill="white"
    />
    <path
      d="M12 6.18789H21.4875C21.075 5.55039 20.625 4.98789 20.1375 4.46289H12V6.18789Z"
      fill="#B22334"
    />
    <path
      d="M12 7.9125H22.3875C22.125 7.3125 21.825 6.7125 21.4875 6.1875H12V7.9125Z"
      fill="white"
    />
    <path
      d="M12 9.63809H22.95C22.8 9.03809 22.6125 8.47559 22.3875 7.91309H12V9.63809Z"
      fill="#B22334"
    />
    <path
      d="M12 11.3998H23.2125C23.175 10.7998 23.0625 10.2373 22.95 9.6748H12V11.3998Z"
      fill="white"
    />
    <path
      d="M23.2125 11.4004H12V12.2629H0.75C0.75 12.5629 0.75 12.8254 0.7875 13.1254H23.2125C23.25 12.8254 23.25 12.5629 23.25 12.2629C23.25 11.9629 23.25 11.6629 23.2125 11.4004Z"
      fill="#B22334"
    />
    <path
      d="M1.04998 14.85H22.95C23.1 14.2875 23.175 13.725 23.2125 13.125H0.787476C0.824976 13.6875 0.937476 14.2875 1.04998 14.85Z"
      fill="white"
    />
    <path
      d="M1.61255 16.5756H22.3876C22.6126 16.0131 22.8001 15.4506 22.9501 14.8506H1.05005C1.20005 15.4506 1.38755 16.0131 1.61255 16.5756Z"
      fill="#B22334"
    />
    <path
      d="M2.51255 18.3002H21.4876C21.8251 17.7377 22.1251 17.1752 22.3876 16.5752H1.61255C1.87505 17.1752 2.17505 17.7377 2.51255 18.3002Z"
      fill="white"
    />
    <path
      d="M3.86245 20.0248H20.1374C20.625 19.4998 21.1124 18.8998 21.4874 18.2998H2.51245C2.88745 18.9373 3.37495 19.4998 3.86245 20.0248Z"
      fill="#B22334"
    />
    <path
      d="M5.96255 21.7504H18.0375C18.825 21.2629 19.5001 20.6629 20.1376 20.0254H3.86255C4.50005 20.7004 5.21255 21.2629 5.96255 21.7504Z"
      fill="white"
    />
    <path
      d="M12 23.5125C14.2125 23.5125 16.275 22.875 18.0375 21.75H5.96252C7.72502 22.875 9.78752 23.5125 12 23.5125Z"
      fill="#B22334"
    />
    <path
      d="M6 2.7377C5.2125 3.2252 4.5 3.8252 3.8625 4.4627C3.3375 4.9877 2.8875 5.5877 2.5125 6.1877C2.175 6.7502 1.8375 7.3127 1.6125 7.91269C1.3875 8.47519 1.2 9.03769 1.05 9.6377C0.9 10.2002 0.825 10.7627 0.7875 11.3627C0.75 11.6627 0.75 11.9627 0.75 12.2627H12V1.0127C9.7875 1.0127 7.7625 1.6502 6 2.7377Z"
      fill="#3C3B6E"
    />
    <path
      d="M9.37502 1.3877L9.56252 1.9502H10.125L9.67502 2.3252L9.82502 2.8877L9.37502 2.5502L8.92502 2.8877L9.07502 2.3252L8.62502 1.9502H9.18752L9.37502 1.3877ZM10.875 3.6377L11.0625 4.2002H11.625L11.175 4.5752L11.325 5.1377L10.875 4.8002L10.425 5.1377L10.575 4.5752L10.125 4.2002H10.6875L10.875 3.6377ZM7.87502 3.6377L8.06252 4.2002H8.62502L8.17502 4.5752L8.32502 5.1377L7.87502 4.8002L7.42502 5.1377L7.57502 4.5752L7.12502 4.2002H7.68752L7.87502 3.6377ZM9.37502 5.8877L9.56252 6.4502H10.125L9.67502 6.8252L9.82502 7.3877L9.37502 7.0502L8.92502 7.3877L9.07502 6.8252L8.62502 6.4502H9.18752L9.37502 5.8877ZM6.37502 5.8877L6.56252 6.4502H7.12502L6.67502 6.8252L6.82502 7.3877L6.37502 7.0502L5.92502 7.3877L6.07502 6.8252L5.62502 6.4502H6.18752L6.37502 5.8877ZM3.37502 5.8877L3.56252 6.4502H4.12502L3.67502 6.8252L3.82502 7.3877L3.37502 7.0502L2.92502 7.3877L3.07502 6.8252L2.62502 6.4502H3.18752L3.37502 5.8877ZM10.875 8.1377L11.0625 8.7002H11.625L11.175 9.0752L11.325 9.6377L10.875 9.3002L10.425 9.6377L10.575 9.0752L10.125 8.7002H10.6875L10.875 8.1377ZM7.87502 8.1377L8.06252 8.7002H8.62502L8.17502 9.0752L8.32502 9.6377L7.87502 9.3002L7.42502 9.6377L7.57502 9.0752L7.12502 8.7002H7.68752L7.87502 8.1377ZM4.87502 8.1377L5.06252 8.7002H5.62502L5.17502 9.0752L5.32502 9.6377L4.87502 9.3002L4.42502 9.6377L4.57502 9.0752L4.12502 8.7002H4.68752L4.87502 8.1377ZM9.37502 10.3877L9.56252 10.9502H10.125L9.67502 11.3252L9.82502 11.8877L9.37502 11.5502L8.92502 11.8877L9.07502 11.3252L8.62502 10.9502H9.18752L9.37502 10.3877ZM6.37502 10.3877L6.56252 10.9502H7.12502L6.67502 11.3252L6.82502 11.8877L6.37502 11.5502L5.92502 11.8877L6.07502 11.3252L5.62502 10.9502H6.18752L6.37502 10.3877ZM3.37502 10.3877L3.56252 10.9502H4.12502L3.67502 11.3252L3.82502 11.8877L3.37502 11.5502L2.92502 11.8877L3.07502 11.3252L2.62502 10.9502H3.18752L3.37502 10.3877ZM4.42502 5.1377L4.87502 4.8002L5.32502 5.1377L5.13752 4.5752L5.58752 4.2002H5.02502L4.87502 3.6377L4.68752 4.2002H4.16252L4.61252 4.5377L4.42502 5.1377ZM1.42502 9.6377L1.87502 9.3002L2.32502 9.6377L2.13752 9.0752L2.58752 8.7002H2.06252L1.87502 8.1377L1.68752 8.7002H1.31252C1.31252 8.7377 1.27502 8.7752 1.27502 8.8127L1.57502 9.03769L1.42502 9.6377Z"
      fill="white"
    />
  </svg>
);

export const PunjabiFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M11.925 1.0127C7.04998 1.0127 2.88748 4.1627 1.34998 8.5127H22.575C21 4.1627 16.8375 1.0127 11.925 1.0127Z"
      fill="#E27022"
    />
    <path
      d="M11.925 23.5127C16.8375 23.5127 21 20.4002 22.5375 16.0127H1.34998C2.88748 20.4002 7.04998 23.5127 11.925 23.5127Z"
      fill="#5C9E31"
    />
    <path
      d="M1.35002 8.5127C0.937524 9.6752 0.712524 10.9502 0.712524 12.2627C0.712524 13.5752 0.937524 14.8502 1.35002 16.0127H22.575C22.9875 14.8502 23.2125 13.5752 23.2125 12.2627C23.2125 10.9502 22.9875 9.6752 22.575 8.5127H1.35002Z"
      fill="white"
    />
    <path
      d="M11.925 15.2627C13.5819 15.2627 14.925 13.9195 14.925 12.2627C14.925 10.6058 13.5819 9.2627 11.925 9.2627C10.2682 9.2627 8.92505 10.6058 8.92505 12.2627C8.92505 13.9195 10.2682 15.2627 11.925 15.2627Z"
      fill="#428BC1"
    />
    <path
      d="M11.925 14.8877C13.3748 14.8877 14.55 13.7124 14.55 12.2627C14.55 10.8129 13.3748 9.6377 11.925 9.6377C10.4753 9.6377 9.30005 10.8129 9.30005 12.2627C9.30005 13.7124 10.4753 14.8877 11.925 14.8877Z"
      fill="white"
    />
    <path
      d="M10.9501 10.0127C11.0536 10.0127 11.1376 9.92875 11.1376 9.8252C11.1376 9.72164 11.0536 9.6377 10.9501 9.6377C10.8465 9.6377 10.7626 9.72164 10.7626 9.8252C10.7626 9.92875 10.8465 10.0127 10.9501 10.0127Z"
      fill="#1E50A0"
    />
    <path
      d="M10.35 10.3506C10.4535 10.3506 10.5375 10.2666 10.5375 10.1631C10.5375 10.0595 10.4535 9.97559 10.35 9.97559C10.2464 9.97559 10.1625 10.0595 10.1625 10.1631C10.1625 10.2666 10.2464 10.3506 10.35 10.3506Z"
      fill="#1E50A0"
    />
    <path
      d="M9.86255 10.8379C9.9661 10.8379 10.05 10.7539 10.05 10.6504C10.05 10.5468 9.9661 10.4629 9.86255 10.4629C9.759 10.4629 9.67505 10.5468 9.67505 10.6504C9.67505 10.7539 9.759 10.8379 9.86255 10.8379Z"
      fill="#1E50A0"
    />
    <path
      d="M9.52502 11.4375C9.62858 11.4375 9.71252 11.3536 9.71252 11.25C9.71252 11.1464 9.62858 11.0625 9.52502 11.0625C9.42147 11.0625 9.33752 11.1464 9.33752 11.25C9.33752 11.3536 9.42147 11.4375 9.52502 11.4375Z"
      fill="#1E50A0"
    />
    <path
      d="M9.33752 12.1123C9.44108 12.1123 9.52502 12.0284 9.52502 11.9248C9.52502 11.8213 9.44108 11.7373 9.33752 11.7373C9.23397 11.7373 9.15002 11.8213 9.15002 11.9248C9.15002 12.0284 9.23397 12.1123 9.33752 12.1123Z"
      fill="#1E50A0"
    />
    <path
      d="M9.33752 12.7881C9.44108 12.7881 9.52502 12.7041 9.52502 12.6006C9.52502 12.497 9.44108 12.4131 9.33752 12.4131C9.23397 12.4131 9.15002 12.497 9.15002 12.6006C9.15002 12.7041 9.23397 12.7881 9.33752 12.7881Z"
      fill="#1E50A0"
    />
    <path
      d="M9.52502 13.4629C9.62858 13.4629 9.71252 13.3789 9.71252 13.2754C9.71252 13.1718 9.62858 13.0879 9.52502 13.0879C9.42147 13.0879 9.33752 13.1718 9.33752 13.2754C9.33752 13.3789 9.42147 13.4629 9.52502 13.4629Z"
      fill="#1E50A0"
    />
    <path
      d="M9.86255 14.0625C9.9661 14.0625 10.05 13.9786 10.05 13.875C10.05 13.7714 9.9661 13.6875 9.86255 13.6875C9.759 13.6875 9.67505 13.7714 9.67505 13.875C9.67505 13.9786 9.759 14.0625 9.86255 14.0625Z"
      fill="#1E50A0"
    />
    <path
      d="M10.35 14.5498C10.4535 14.5498 10.5375 14.4659 10.5375 14.3623C10.5375 14.2588 10.4535 14.1748 10.35 14.1748C10.2464 14.1748 10.1625 14.2588 10.1625 14.3623C10.1625 14.4659 10.2464 14.5498 10.35 14.5498Z"
      fill="#1E50A0"
    />
    <path
      d="M10.9501 14.8877C11.0536 14.8877 11.1376 14.8037 11.1376 14.7002C11.1376 14.5966 11.0536 14.5127 10.9501 14.5127C10.8465 14.5127 10.7626 14.5966 10.7626 14.7002C10.7626 14.8037 10.8465 14.8877 10.9501 14.8877Z"
      fill="#1E50A0"
    />
    <path
      d="M11.5875 15.0381C11.6911 15.0381 11.775 14.9541 11.775 14.8506C11.775 14.747 11.6911 14.6631 11.5875 14.6631C11.484 14.6631 11.4 14.747 11.4 14.8506C11.4 14.9541 11.484 15.0381 11.5875 15.0381Z"
      fill="#1E50A0"
    />
    <path
      d="M12.1125 14.8881C12.1125 14.7756 12.1875 14.7006 12.2625 14.6631C12.375 14.6631 12.45 14.7381 12.4875 14.8131C12.4875 14.9256 12.4125 15.0006 12.3375 15.0381C12.1875 15.0756 12.1125 15.0006 12.1125 14.8881Z"
      fill="#1E50A0"
    />
    <path
      d="M12.9375 14.8877C13.0411 14.8877 13.125 14.8037 13.125 14.7002C13.125 14.5966 13.0411 14.5127 12.9375 14.5127C12.8339 14.5127 12.75 14.5966 12.75 14.7002C12.75 14.8037 12.8339 14.8877 12.9375 14.8877Z"
      fill="#1E50A0"
    />
    <path
      d="M13.5375 14.5498C13.641 14.5498 13.725 14.4659 13.725 14.3623C13.725 14.2588 13.641 14.1748 13.5375 14.1748C13.4339 14.1748 13.35 14.2588 13.35 14.3623C13.35 14.4659 13.4339 14.5498 13.5375 14.5498Z"
      fill="#1E50A0"
    />
    <path
      d="M14.025 14.0625C14.1286 14.0625 14.2125 13.9786 14.2125 13.875C14.2125 13.7714 14.1286 13.6875 14.025 13.6875C13.9215 13.6875 13.8375 13.7714 13.8375 13.875C13.8375 13.9786 13.9215 14.0625 14.025 14.0625Z"
      fill="#1E50A0"
    />
    <path
      d="M14.3625 13.4629C14.4661 13.4629 14.55 13.3789 14.55 13.2754C14.55 13.1718 14.4661 13.0879 14.3625 13.0879C14.259 13.0879 14.175 13.1718 14.175 13.2754C14.175 13.3789 14.259 13.4629 14.3625 13.4629Z"
      fill="#1E50A0"
    />
    <path
      d="M14.55 12.7881C14.6536 12.7881 14.7375 12.7041 14.7375 12.6006C14.7375 12.497 14.6536 12.4131 14.55 12.4131C14.4465 12.4131 14.3625 12.497 14.3625 12.6006C14.3625 12.7041 14.4465 12.7881 14.55 12.7881Z"
      fill="#1E50A0"
    />
    <path
      d="M14.5501 12.1123C14.4376 12.1123 14.3626 12.0373 14.3251 11.9623C14.3251 11.8498 14.4001 11.7748 14.4751 11.7373C14.5876 11.7373 14.6626 11.8123 14.7001 11.8873C14.7376 11.9998 14.6626 12.0748 14.5501 12.1123Z"
      fill="#1E50A0"
    />
    <path
      d="M14.3625 11.4375C14.4661 11.4375 14.55 11.3536 14.55 11.25C14.55 11.1464 14.4661 11.0625 14.3625 11.0625C14.259 11.0625 14.175 11.1464 14.175 11.25C14.175 11.3536 14.259 11.4375 14.3625 11.4375Z"
      fill="#1E50A0"
    />
    <path
      d="M14.025 10.8379C14.1286 10.8379 14.2125 10.7539 14.2125 10.6504C14.2125 10.5468 14.1286 10.4629 14.025 10.4629C13.9215 10.4629 13.8375 10.5468 13.8375 10.6504C13.8375 10.7539 13.9215 10.8379 14.025 10.8379Z"
      fill="#1E50A0"
    />
    <path
      d="M13.5375 10.3506C13.641 10.3506 13.725 10.2666 13.725 10.1631C13.725 10.0595 13.641 9.97559 13.5375 9.97559C13.4339 9.97559 13.35 10.0595 13.35 10.1631C13.35 10.2666 13.4339 10.3506 13.5375 10.3506Z"
      fill="#1E50A0"
    />
    <path
      d="M13.125 9.90018C13.0875 10.0127 12.975 10.0502 12.8625 10.0127C12.75 9.97518 12.7125 9.86268 12.75 9.75018C12.7875 9.63768 12.9 9.60018 13.0125 9.63768C13.125 9.71268 13.1625 9.82518 13.125 9.90018ZM12.45 9.67518C12.45 9.78768 12.3375 9.86268 12.225 9.82518C12.1125 9.82518 12.0375 9.71268 12.075 9.60018C12.075 9.48768 12.1875 9.41268 12.3 9.45018C12.4125 9.48768 12.4875 9.60018 12.45 9.67518ZM11.775 9.63768C11.775 9.75018 11.7 9.82518 11.625 9.86268C11.5125 9.86268 11.4375 9.78768 11.4 9.71268C11.4 9.60018 11.475 9.52518 11.55 9.48768C11.6625 9.45018 11.775 9.52518 11.775 9.63768Z"
      fill="#1E50A0"
    />
    <path
      d="M11.925 12.8252C12.2357 12.8252 12.4875 12.5734 12.4875 12.2627C12.4875 11.952 12.2357 11.7002 11.925 11.7002C11.6144 11.7002 11.3625 11.952 11.3625 12.2627C11.3625 12.5734 11.6144 12.8252 11.925 12.8252Z"
      fill="#1E50A0"
    />
    <path
      d="M11.925 9.6377L11.85 11.2502L11.925 12.2627L12.0375 11.2502L11.925 9.6377ZM11.25 9.7127L11.5875 11.3252L11.925 12.2627L11.775 11.2502L11.25 9.7127Z"
      fill="#1E50A0"
    />
    <path
      d="M10.6125 9.97559L11.3625 11.4381L11.925 12.2631L11.5125 11.3256L10.6125 9.97559ZM10.0875 10.3881L11.175 11.6256L11.925 12.2631L11.2875 11.4756L10.0875 10.3881Z"
      fill="#1E50A0"
    />
    <path
      d="M9.67505 10.9502L11.025 11.8502L11.925 12.2627L11.1 11.6627L9.67505 10.9502Z"
      fill="#1E50A0"
    />
    <path
      d="M9.41255 11.5879L10.95 12.0754L11.925 12.2629L10.9875 11.9254L9.41255 11.5879ZM9.30005 12.2629L10.95 12.3379L11.925 12.2629L10.95 12.1879L9.30005 12.2629Z"
      fill="#1E50A0"
    />
    <path
      d="M9.41248 12.9377L10.9875 12.6002L11.925 12.2627L10.95 12.4502L9.41248 12.9377ZM9.67498 13.5752L11.1 12.8627L11.925 12.2627L11.025 12.6752L9.67498 13.5752Z"
      fill="#1E50A0"
    />
    <path
      d="M10.0875 14.1002L11.2875 13.0502L11.925 12.2627L11.175 12.9002L10.0875 14.1002ZM10.6125 14.5502L11.5125 13.1627L11.925 12.2627L11.3625 13.0877L10.6125 14.5502Z"
      fill="#1E50A0"
    />
    <path
      d="M11.25 14.8127L11.775 13.2752L11.925 12.2627L11.5875 13.2002L11.25 14.8127ZM11.925 14.8877L12.0375 13.2752L11.925 12.2627L11.85 13.2752L11.925 14.8877ZM12.6 14.8127L12.3 13.2002L11.925 12.2627L12.1125 13.2752L12.6 14.8127Z"
      fill="#1E50A0"
    />
    <path
      d="M13.2375 14.5502L12.525 13.0877L11.925 12.2627L12.375 13.2002L13.2375 14.5502ZM13.8 14.1002L12.7125 12.9002L11.925 12.2627L12.6 13.0502L13.8 14.1002Z"
      fill="#1E50A0"
    />
    <path
      d="M14.2125 13.5754L12.8625 12.6754L11.925 12.2629L12.75 12.8629L14.2125 13.5754ZM14.475 12.9379L12.9375 12.4504L11.925 12.2629L12.9 12.6004L14.475 12.9379ZM14.55 12.2629L12.9375 12.1504L11.925 12.2629L12.9375 12.3379L14.55 12.2629ZM14.475 11.5879L12.9 11.9254L11.925 12.2629L12.9375 12.0754L14.475 11.5879Z"
      fill="#1E50A0"
    />
    <path
      d="M14.2125 10.9498L12.75 11.6623L11.925 12.2623L12.8625 11.8498L14.2125 10.9498ZM13.8 10.4248L12.6 11.4748L11.925 12.2623L12.7125 11.6248L13.8 10.4248Z"
      fill="#1E50A0"
    />
    <path
      d="M13.2375 9.97559L12.375 11.3631L11.925 12.2631L12.525 11.4381L13.2375 9.97559Z"
      fill="#1E50A0"
    />
    <path
      d="M12.6375 9.71289L12.1125 11.2504L11.925 12.2629L12.3 11.3254L12.6375 9.71289Z"
      fill="#1E50A0"
    />
  </svg>
);

export const MandarinFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M12 23.5127C18.2132 23.5127 23.25 18.4759 23.25 12.2627C23.25 6.04949 18.2132 1.0127 12 1.0127C5.7868 1.0127 0.75 6.04949 0.75 12.2627C0.75 18.4759 5.7868 23.5127 12 23.5127Z"
      fill="#DE2910"
    />
    <path
      d="M8.25 10.9127L11.25 13.0127L10.125 9.5627L13.125 7.3877H9.4125L8.25 4.0127L7.125 7.3877H3.375L6.375 9.5627L5.25 13.0127L8.25 10.9127ZM13.2375 13.5002L12.375 13.6877L13.2 14.0252V14.8877L13.7625 14.2502L14.5875 14.5502L14.1 13.8377L14.625 13.1627L13.7625 13.3502L13.2375 12.6377V13.5002ZM14.5125 10.9502L13.875 11.5127L14.7375 11.4377L15.1125 12.2627L15.2625 11.4002L16.125 11.3252L15.375 10.8752L15.5625 10.0127L14.925 10.5752L14.175 10.1252L14.5125 10.9502ZM14.7375 8.0252L15 8.8877L15.2625 8.0627H16.125L15.45 7.5377L15.7125 6.6752L15 7.2002L14.325 6.6377L14.5875 7.5002L13.875 7.9877L14.7375 8.0252ZM13.2375 5.0252V5.8877L13.7625 5.1752L14.625 5.3627L14.1 4.6877L14.5875 3.9752L13.7625 4.3127L13.2 3.6377V4.5002L12.375 4.8377L13.2375 5.0252Z"
      fill="#FFE62E"
    />
  </svg>
);

// export const  = () => ()
